export const CHANGE_MENU = 'CHANGE_MENU';
export const TOGGLE_LOGIN_PANEL_VISIBLE = 'TOGGLE_LOGIN_PANEL_VISIBLE';
export const CHANGE_AUTHING_PANEL = 'CHANGE_AUTHING_PANEL';
export const TOGGLE_MENU_VISIBLE = 'TOGGLE_MENU_VISIBLE';
export const TOGGLE_CHART_RECREATED = 'TOGGLE_CHART_RECREATED';
export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';